import React, { useState } from "react";
import styles from "./style.module.css";
import classNames from "classnames";
import { ArrowLeft } from "react-bootstrap-icons";

export const CardHome = () => {
  const [flag, setFlag] = useState(false);
  const [flag1, setFlag1] = useState(false);
  const [flag2, setFlag2] = useState(false);
  const [flag3, setFlag3] = useState(false);
  const [flag4, setFlag4] = useState(false);

  const handleHover = () => {
    setFlag(true);
  };
  const handleHover1 = () => {
    setFlag1(!flag1);
  };
  const handleHover2 = () => {
    setFlag2(!flag2);
  };
  const handleHover3 = () => {
    setFlag3(!flag3);
  };
  const handleHover4 = () => {
    setFlag4(!flag4);
  };
  return (
    <>
      <div className={styles.sectionCardHome}>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-4 d-flex justify-content-center align-items-center mb-3">
              {/*<div className="p-1">*/}
              {/*    <img src={"/asset/images/homeImage/xbxb.png"} className="img-fluid" alt=""/>*/}
              {/*    <div className={styles.tittleImage}><a href="/#" style={{color:"white !important"}}>دوره های آموزشی</a></div>*/}
              {/*</div>*/}
              <a
                href="https://reg.mobinsb.ir"
                className="d-flex justify-content-center "
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <div
                  className={classNames(styles.backImage)}
                  onMouseEnter={handleHover}
                  onMouseLeave={() => setFlag(false)}
                >
                  <h3
                    style={{ color: "white" }}
                    className={
                      flag ? styles.hoverTitleActive : styles.hoverTitle
                    }
                    onMouseEnter={handleHover}
                  >
                    افتتاح حساب
                  </h3>

                  <div
                    className={flag ? styles.hoverTextActive : styles.hoverText}
                  >
                    <div>
                      <p style={{ color: "white", fontSize: "12px" }}>
                        مجموعه‌ای از متنوع‌ترین امکانات و خدمات مالی فقط در
                        باشگاه مشتریان!
                      </p>
                    </div>
                    {/*<img*/}
                    {/*  src={"/asset/images/homeImage/logoHome/image/481127.png"}*/}
                    {/*  className="img-fluid"*/}
                    {/*  alt=""*/}
                    {/*  width="40"*/}
                    {/*/>*/}
                    <ArrowLeft
                      color={"white"}
                      style={{ fontSize: "60px" }}
                      className={
                        flag ? styles.hoverIconActive : styles.hoverIcon
                      }
                    />
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-lg-4 d-flex justify-content-center align-items-center mb-3">
              {/*<div className="p-1">*/}
              {/*  <img*/}
              {/*    src={"/asset/images/homeImage/iStock-1011244876-1200x800.png"}*/}
              {/*    className="img-fluid"*/}
              {/*    alt=""*/}
              {/*  />*/}
              {/*  <div className={styles.tittleImage}>*/}
              {/*    <a href="/#" style={{ color: "white !important" }}>*/}
              {/*      دوره های آموزشی{" "}*/}
              {/*      <p style={{ fontSize: "11px" }}>*/}
              {/*        مجموعه‌ای متنوع‌ترین امکانات و خدمات مالی فقط در باشگاه*/}
              {/*        مشتریان!*/}
              {/*      </p>*/}
              {/*    </a>*/}
              {/*  </div>*/}
              {/*</div>*/}
              <a
                href="http://club.mobinsb.ir/"
                className="d-flex justify-content-center "
                target="_blank"
                rel="noreferrer"
              >
                <div
                  className={classNames(styles.backImage1)}
                  onMouseEnter={handleHover1}
                  onMouseLeave={() => setFlag1(false)}
                >
                  <h3
                    style={{ color: "white" }}
                    className={
                      flag1 ? styles.hoverTitleActive : styles.hoverTitle
                    }
                  >
                    باشگاه مشتریان{" "}
                  </h3>

                  <div
                    className={
                      flag1 ? styles.hoverTextActive : styles.hoverText
                    }
                  >
                    <div>
                      <p style={{ color: "white", fontSize: "12px" }}>
                        مجموعه‌ای از متنوع‌ترین امکانات و خدمات مالی فقط در
                        باشگاه مشتریان!
                      </p>
                    </div>
                    {/*<img*/}
                    {/*  src={"/asset/images/homeImage/logoHome/image/481127.png"}*/}
                    {/*  className="img-fluid"*/}
                    {/*  alt=""*/}
                    {/*  width="40"*/}
                    {/*/>*/}
                    <ArrowLeft
                      color={"white"}
                      style={{ fontSize: "60px" }}
                      className={
                        flag1 ? styles.hoverIconActive : styles.hoverIcon
                      }
                    />
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-lg-4 d-flex justify-content-center align-items-center mb-3">
              <a
                href="https://fund.mobinsb.ir/"
                className="d-flex justify-content-center "
                target="_blank"
                rel="noreferrer"
              >
                <div
                  className={classNames(styles.backImage2)}
                  onMouseEnter={handleHover2}
                  onMouseLeave={() => setFlag2(false)}
                >
                  <h3
                    style={{ color: "white" }}
                    className={
                      flag2 ? styles.hoverTitleActive : styles.hoverTitle
                    }
                  >
                    صندوق سرمایه گذاری{" "}
                  </h3>
                  <div
                    className={
                      flag2 ? styles.hoverTextActive : styles.hoverText
                    }
                  >
                    <div>
                      <p style={{ color: "white", fontSize: "12px" }}>
                        صندوق سرمایه‌گذاری یک نهاد مالی تحت نظارت سازمان بورس و
                        اوراق بهادار است، که بر اساس دانش متخصصان مالی اقدام...
                      </p>
                    </div>
                    <ArrowLeft
                      color={"white"}
                      style={{ fontSize: "60px" }}
                      className={
                        flag2 ? styles.hoverIconActive : styles.hoverIcon
                      }
                    />
                  </div>
                </div>
              </a>
            </div>
            {/* ..... */}

            <div className="col-12 col-lg-6 justify-content-center align-items-center mb-3">
              <a
                href="https://mobinhub.mobinsb.ir/"
                className="d-flex justify-content-center "
                target="_blank"
                rel="noreferrer"
              >
                <div
                  className={classNames(styles.backImage3)}
                  onMouseEnter={handleHover3}
                  onMouseLeave={() => setFlag3(false)}
                >
                  <h3
                    style={{ color: "white" }}
                    className={
                      flag3 ? styles.hoverTitleActive : styles.hoverTitle
                    }
                  >
                    مبین هاب{" "}
                  </h3>
                  <div
                    className={
                      flag3 ? styles.hoverTextActive : styles.hoverText
                    }
                  >
                    <div>
                      <p style={{ color: "white", fontSize: "12px" }}>
                        مبین سرمایه نقطه اتصال بازار سرمایه به اکوسیستم
                        استارتاپی کشور فراهم‌سازی امکان مشارکت عمومی در طرح‌های
                        توسعه کسب‌وکارهای کوچک و متوسط...
                      </p>
                    </div>
                    <ArrowLeft
                      color={"white"}
                      style={{ fontSize: "60px" }}
                      className={
                        flag3 ? styles.hoverIconActive3 : styles.hoverIcon3
                      }
                    />
                  </div>
                </div>
              </a>
            </div>

            <div className="col-12 col-lg-6 justify-content-center align-items-center mb-3">
              <a
                href="https://smartpro.mobinsb.ir/"
                className="d-flex justify-content-center "
                target="_blank"
                rel="noreferrer"
              >
                <div
                  className={classNames(styles.backImage4)}
                  onMouseEnter={handleHover4}
                  onMouseLeave={() => setFlag4(false)}
                >
                  <h3
                    style={{ color: "white" }}
                    className={
                      flag4 ? styles.hoverTitleActive : styles.hoverTitle
                    }
                  >
                    سامانه معاملاتی اسمارت{" "}
                  </h3>
                  <div
                    className={
                      flag4 ? styles.hoverTextActive : styles.hoverText
                    }
                  >
                    <div>
                      <p style={{ color: "white", fontSize: "12px" }}>
                        سامانه معاملات برخط کارگزاری مبین سرمایه اسمارت معامله
                        کنید
                      </p>
                    </div>
                    <ArrowLeft
                      color={"white"}
                      style={{ fontSize: "60px" }}
                      className={
                        flag4 ? styles.hoverIconActive2 : styles.hoverIcon2
                      }
                    />
                  </div>
                </div>
              </a>
            </div>

            {/* ..... */}
          </div>
        </div>
      </div>
    </>
  );
};
